module.exports = __webpack_public_path__ + "img/陆元盛@2x.778727d8.png";